const MessageTypingAnimation = () => {
  return (
    <span className='mp-agent-message-typing-bubble'>
      <span className='mp-agent-message-typing-dot' />
      <span className='mp-agent-message-typing-dot' />
      <span className='mp-agent-message-typing-dot' />
    </span>
  )
}
export default MessageTypingAnimation
